export default "__VITE_ASSET__c89992b2__"